import request from './request';
// 导入极验验证，导入后可通过window.initGeetest进行访问
// 极验验证，验证预处理api
// eslint-disable-next-line
import geetest from "../plugin/geetest/geetest.gt"
export function getGtCaptcha () {
  let url = '/api/a/gt/register';
  return request({
    method: 'get',
    url: url,
    withCredentials: true,
  });
}
